<template>
    <div class="pdf-viewer" :url="url">
        <div class="iframeToolbar">
            <button @click="close">FECHAR</button>
            
        </div>
        <iframe :src="url"></iframe>
    </div>
</template>
<script>
export default {
    props: ["url"],
    data() {
        return {
            showIframe: this.value || false,
        };
    },
    methods: {
        close() {
            this.$emit("close");
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.showIframe = value || false;
            },
        },
    },
    created() {
        document.querySelector("html").classList.add("hide-overflow");
    },
    destroyed() {
        document.querySelector("html").classList.remove("hide-overflow");
    },
};
</script>

<style lang="less" scoped>
    .pdf-viewer {
        widows: 100vw;
        height: 100vh;;
        position: fixed;
        top: 0;
        left: 0;
        background: black;
        z-index: 9999;
        iframe {
            width: 100vw;            
            height: ~"calc(100vh - 48px)";            
        }
        .iframeToolbar {
            width: 100vw;
            height: 48px;
            background: black;
            display: flex;
            justify-content: flex-end;
            button {
                margin-right: 20px;
                background: transparent;
                color: white;
                padding: 0 2em;
                border: none;
                cursor: pointer;
            }            
        }
    }
</style>
<style lang="less">
    html.hide-overflow {
        overflow: hidden;
        body {
            overflow: hidden;
        }
    }
</style>